import { gql } from "@apollo/client";

export const GET_FINANCIAL_INFORMATION = gql`
  query GetFinancialInformation(
    $establishmentId: String!
    $financialInformationId: String!
  ) {
    QR_GET_FINANCIAL_INFORMATION(
      establishmentId: $establishmentId
      financialInformationId: $financialInformationId
    ) {
      code
      data {
        id
        bankName
        accountHolder
        rib
      }
    }
  }
`;

export const ADD_FINANCIAL_INFORMATION_MUTATION = gql`
  mutation AddFinancialInformation(
    $establishmentId: String!
    $financialInformationInput: FinancialInformationInput!
  ) {
    MT_ADD_FINANCIAL_INFORMATION(
      establishmentId: $establishmentId
      financialInformationInput: $financialInformationInput
    ) {
      code
      data {
        id
      }
    }
  }
`;

export const UPDATE_FINANCIAL_INFORMATION_MUTATION = gql`
  mutation UpdateFinancialInformation(
    $establishmentId: String!
    $financialInformationId: String!
    $financialInformationInput: FinancialInformationInput!
  ) {
    MT_UPDATE_FINANCIAL_INFORMATION(
      establishmentId: $establishmentId
      financialInformationId: $financialInformationId
      financialInformationInput: $financialInformationInput
    ) {
      code
      data {
        id
      }
    }
  }
`;
